import React from "react"
import { HeroTertiaryType } from "../../types/heroTypes"
import { API } from "../../constants/constants"
import BaseRichtext from "../common/BaseRichtext"
import BaseHeadline from "../common/BaseHeadline"

export default function HeroTertiary(props: HeroTertiaryType) {
    return (
        <div className="max-w-content mx-auto flex flex-col px-4 lg:flex-row gap-4 items-center pt-4 pb-16 lg:py-16">
            <div className="w-full lg:w-1/2">
                <BaseHeadline headlineType={1} label={props?.heroTertiaryHeading} />
                <BaseRichtext content={props?.heroTertiaryText} classProps="pb-4" />
                <img
                    src={API + props?.heroTertiaryIcon?.url}
                    alt={props.heroTertiaryIcon?.description ?? props.heroTertiaryIcon.name ?? "HeroIcon"}
                    className="w-16 lg:w-24 mx-auto !text-primary"
                />
            </div>
            <img
                src={API + props?.heroTertiaryImage?.url}
                alt={props?.heroTertiaryImage?.description ?? props.heroTertiaryImage.name ?? "HeroImage"}
                className="w-full h-64 lg:h-auto lg:w-1/2 aspect-[6/5] object-cover rounded-default"
            />
        </div>
    )
}
